import { Link } from 'react-router-dom'
import alternativeHospitalImage from 'assets/alternativeHospital.jpg'
import LazyImage from '@/components/common/LazyImage'


export default function VideoList() {

    const videos = [
        {
            id: 'specialty',
            name: '坊間手術「麻醉」黑幕！',
            description: '各大手術中，麻醉扮演極重要角色，但卻經常被忽略！坊間不少醫療院所為了削價競爭，沒有專業麻醉醫師到場，對於病患來說具有相當大的風險，一不注意就可能造成致命危險。',
            image: 'https://video.ratetwansafe.com/TestFiles/1.png',
            created_at: '2025-01-08',
            link: 'https://www.youtube.com/watch?v=sG3ybr-PLPA'
        },
        {
            id: 'city',
            name: '醫美診所的暗黑預算',
            description: '您喜歡醫美嗎 ? 您知道醫美診所明知自己不聘用專業的麻醉科醫師會出事，甚至編列預算給致死的家屬，但就是不請專業的麻醉科醫師嗎 ? ',
            image: 'https://video.ratetwansafe.com/TestFiles/2.png',
            created_at: '2025-01-01',
            link: 'https://video.ratetwansafe.com/song.mp4'
        },
        {
            id: 'district',
            name: '讓手術醫師進行麻醉 ? ',
            description: '術業有專攻，為何專業人士都說 "立委提的手術醫師進行麻醉訓練是非常不合理的" ? ',
            image: 'https://video.ratetwansafe.com/TestFiles/3.png',
            created_at: '2024-12-08',
            link: 'https://video.ratetwansafe.com/soft_song.mp4'
        },
    ];

    return (
        <div>
            <main>
                <div className="px-4 mx-auto max-w-5xl sm:px-6 lg:px-8">
                    {
                        videos.map((item) => (
                            <Link
                                to={item.link}
                                className="block"
                            >
                                <article className="relative flex flex-col gap-8 px-4 py-5 rounded-lg isolate lg:flex-row hover:bg-gray-50">
                                    <div className="relative aspect-[16/9] sm:aspect-[2/1] lg:aspect-[16/9] lg:w-60 lg:shrink-0">
                                        <div className="absolute inset-0">
                                            <LazyImage
                                                alt="Hospital Image"
                                                src={item.image}
                                                fallbackSrc={
                                                    alternativeHospitalImage
                                                }
                                                className="absolute inset-0 object-cover w-full h-full rounded-2xl bg-gray-50"
                                            />
                                            <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                                        </div>
                                    </div>
                                    <div className="flex-1">
                                        <div className="relative max-w-xl group">
                                            <h3 className="mt-1 text-2xl font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                                                <span>
                                                    <span className="absolute inset-0" />
                                                    {item.name}
                                                </span>
                                            </h3>
                                            <p>
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </Link>
                        ))
                    }
                </div>
            </main>
        </div>
    )
}
